import { localStorageSupported } from '#lib/helper/browser.js';
import { generateUUID } from '#lib/helper/uuid.js';
import { UserDeviceType } from '#lib/types/generated/index.js';

export const guessDeviceType = (): UserDeviceType => {
	const userAgent = navigator.userAgent;

	if (/android/i.test(userAgent)) {
		// Check if viewport is larger than 768px
		if (window.innerWidth > 768) {
			return UserDeviceType.Tablet;
		} else {
			return UserDeviceType.Mobile;
		}
	} else if (/iPad/.test(userAgent) && !('MSStream' in window)) {
		return UserDeviceType.Tablet;
	} else if (/iPhone|iPod/.test(userAgent) && !('MSStream' in window)) {
		return UserDeviceType.Mobile;
	} else {
		return UserDeviceType.Desktop;
	}
};

export const getDeviceUuid = (): string => {
	if (!localStorageSupported()) {
		return generateUUID();
	}

	const deviceUuid = localStorage.getItem('deviceUuid');
	if (deviceUuid) {
		return deviceUuid;
	}

	const newDeviceUuid = generateUUID();
	localStorage.setItem('deviceUuid', newDeviceUuid);
	return newDeviceUuid;
};
